import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F3F3F3" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.25 12.75v-.25a3.75 3.75 0 00-3.75-3.75h-2a3.75 3.75 0 00-3.75 3.75V16c0 1.598.79 3.012 2 3.873v.877H17c-.948 0-1.857.358-2.55 1h-4.09c-.538 0-1.015.344-1.185.855l-.887 2.658a.748.748 0 00-.038.251V28a1.252 1.252 0 001.25 1.25h7c.097 0 .192-.011.282-.032.07.02.142.032.218.032h11.5c.69 0 1.25-.56 1.25-1.25v-3.5A3.75 3.75 0 0026 20.75h-1.75v-.877c1.21-.86 2-2.275 2-3.873v-1.75H28a.75.75 0 000-1.5h-1.75zm-16.209 12h5.918l-.5-1.5h-4.918l-.5 1.5zm6.209 1.5h-6.5v1.5h6.5v-1.5zm1.5-.736a.747.747 0 00-.038-.251l-.887-2.658a1.25 1.25 0 00-.166-.329c.112-.017.226-.026.341-.026h1.854a2.751 2.751 0 005.292 0H26a2.25 2.25 0 012.25 2.25v3.25h-10.5v-2.236zm7-11.264h-6.5V16a3.25 3.25 0 106.5 0v-1.75zm0-1.5h-6.5v-.25a2.25 2.25 0 012.25-2.25h2a2.25 2.25 0 012.25 2.25v.25zm-4.5 7.834v.917a1.25 1.25 0 002.5-.001v-.916a4.758 4.758 0 01-2.5 0zm4.25 5.666a.75.75 0 010-1.5H26a.75.75 0 010 1.5h-1.5z"
        fill="#000"
        fillOpacity={0.6}
      />
    </Svg>
  );
}

export default SvgComponent;
